<div id="intensity-heatmap" style="width: 100%;"></div>